<template>
  <ItemRow>
    <ItemWithLabel
      :column="columns[0]"
    >
      <EditableName
        :webAuthnKey="itemData"
      />
    </ItemWithLabel>
    <ItemWithLabel
      :class="$style.date"
      :column="columns[1]"
    >
      {{ formattedDateCreated }}
    </ItemWithLabel>
    <ItemWithLabel
      :column="columns[2]"
    >
      <DeleteKey :webAuthnKey="itemData" />
    </ItemWithLabel>
  </ItemRow>
</template>

<script>
import { ItemRow, ItemWithLabel } from '@jumpcloud/ui-components';
import DateUtil from 'client/util/DateUtil';
import DeleteKey from 'client/systemusers/UserDetails/WebAuthnKeys/DeleteKey.vue';
import EditableName from 'client/systemusers/UserDetails/WebAuthnKeys/EditableName.vue';

export default {
  name: 'KeyTableRow',

  components: {
    DeleteKey,
    EditableName,
    ItemRow,
    ItemWithLabel,
  },

  props: {
    columns: {
      type: Array,
      default: () => ([]),
    },
    itemData: {
      type: Object,
      required: true,
    },
  },

  computed: {
    formattedDateCreated() {
      return DateUtil.customFormatDate(this.itemData.registrationDate, 'MMM DD, YYYY');
    },
  },
};
</script>

<style module>
.date {
  margin: auto 0;
}
</style>
